import { useState, useEffect } from 'react';
import { BreakpointsEnum } from '@hooks/element-size-hooks/BreakpointsEnum';



const useIsSmallScreen = (breakpoint: number = BreakpointsEnum.main) => {
	
	const [ isSmallScreen, setIsSmallScreen ] = useState(false);
	const checkScreenSize = () => setIsSmallScreen(window.innerWidth < breakpoint);
	
	useEffect(() => {
		checkScreenSize();
		window.addEventListener('resize', checkScreenSize);
		return () => {
			window.removeEventListener('resize', checkScreenSize);
		}
	}, []);

	return isSmallScreen;
};

export default useIsSmallScreen;